import React, { Component } from 'react';
import Step5Download from './Step5Download';
import Step5Form from './Step5Form';

class Step5 extends Component {   
    render() {
        const { submitted, pdfUrl } = this.props;
        let displayView;

        if (submitted) {
            displayView = <Step5Download pdfUrl={pdfUrl} />;
        } else {
            displayView = <Step5Form />;
        }
        return (
            displayView
        )
    }
}
  
export default Step5;